import { render, staticRenderFns } from "./KioskReservationsPage.vue?vue&type=template&id=22fc10fe&scoped=true"
import script from "./KioskReservationsPage.vue?vue&type=script&lang=js"
export * from "./KioskReservationsPage.vue?vue&type=script&lang=js"
import style0 from "./KioskReservationsPage.vue?vue&type=style&index=0&id=22fc10fe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fc10fe",
  null
  
)

export default component.exports